// UNLV's undergraduate majors (#2748). Read on 2026-10-01 from UNLV's
// official Degrees Directory on unlv.edu (Academics, Degrees Directory, By
// College/School): each college or school's page lists its degrees, and every
// bachelor's degree there is kept, with the degree written as UNLV writes it
// ("Bachelor of Science in Engineering" for the engineering majors, "Bachelor
// of Art in Creative Practice" as printed). Minors, certificates and graduate
// degrees are left out; the Dental Medicine, Graduate College, Honors
// College, Law and Medicine pages list no bachelor's degrees. Cybersecurity
// and the two entertainment design degrees are listed by two colleges and
// appear under both. The 2026-2027 Undergraduate Catalog (catalog.unlv.edu)
// sits behind a robot check that blocks automated reading, so the Degrees
// Directory is the source. The KB's majors list was not needed.
const majors = {
    "slug": "university-of-nevada-las-vegas",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree in UNLV's official Degrees Directory, grouped by the college or school that offers it, with the degree it leads to. A degree two colleges share appears under both. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Lee Business School",
            "source": {
                "label": "UNLV Degrees Directory, Lee Business School",
                "url": "https://www.unlv.edu/academics/degrees/unit/15628"
            },
            "majors": [
                {
                    "name": "Business Administration, Accounting",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Business Administration, Economics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Business Administration, Entrepreneurship",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Business Administration, Finance",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Business Administration, Information Systems",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Business Administration, Insurance and Risk Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Business Administration, International Business",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Business Administration, Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Business Administration, Marketing",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Business Administration, Real Estate",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Economics",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "UNLV Degrees Directory, College of Education",
                "url": "https://www.unlv.edu/academics/degrees/unit/15624"
            },
            "majors": [
                {
                    "name": "Early Childhood Education",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Elementary Education",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Human Services",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Secondary Education",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Special Education",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "Howard R. Hughes College of Engineering",
            "source": {
                "label": "UNLV Degrees Directory, Howard R. Hughes College of Engineering",
                "url": "https://www.unlv.edu/academics/degrees/unit/15609"
            },
            "majors": [
                {
                    "name": "Civil Engineering",
                    "degree": "Bachelor of Science in Engineering"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "Bachelor of Science in Engineering"
                },
                {
                    "name": "Computer Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Computer Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Construction Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "Bachelor of Science in Engineering"
                },
                {
                    "name": "Engineering Technology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Entertainment Engineering and Design",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Entertainment Technology and Design",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "Bachelor of Science in Engineering"
                }
            ]
        },
        {
            "name": "College of Fine Arts",
            "source": {
                "label": "UNLV Degrees Directory, College of Fine Arts",
                "url": "https://www.unlv.edu/academics/degrees/unit/15617"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Art",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Art",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Art History",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Audio Production",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Creative Practice",
                    "degree": "Bachelor of Art"
                },
                {
                    "name": "Dance",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Entertainment Engineering and Design",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Entertainment Technology and Design",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Film",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Graphic Design and Media",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Interior Architecture and Design",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Jazz and Commercial Music",
                    "degree": "Bachelor of Music"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "Bachelor of Landscape Architecture"
                },
                {
                    "name": "Music",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Music",
                    "degree": "Bachelor of Music"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "William F. Harrah College of Hospitality",
            "source": {
                "label": "UNLV Degrees Directory, William F. Harrah College of Hospitality",
                "url": "https://www.unlv.edu/academics/degrees/unit/15607"
            },
            "majors": [
                {
                    "name": "Hospitality Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Sport Hospitality Management",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "School of Integrated Health Sciences",
            "source": {
                "label": "UNLV Degrees Directory, School of Integrated Health Sciences",
                "url": "https://www.unlv.edu/academics/degrees/unit/15612"
            },
            "majors": [
                {
                    "name": "Applied Health Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Comprehensive Medical Imaging",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Health Physics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Kinesiology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Nutrition Sciences",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Liberal Arts",
            "source": {
                "label": "UNLV Degrees Directory, College of Liberal Arts",
                "url": "https://www.unlv.edu/academics/degrees/unit/15608"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Children's Behavioral Health Psychology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "English",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "General Studies in Liberal Arts",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "History",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Neuroscience",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Philosophy",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Political Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Psychology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Sociology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "World Languages & Cultures",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "School of Nursing",
            "source": {
                "label": "UNLV Degrees Directory, School of Nursing",
                "url": "https://www.unlv.edu/academics/degrees/unit/15622"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "School of Public Health",
            "source": {
                "label": "UNLV Degrees Directory, School of Public Health",
                "url": "https://www.unlv.edu/academics/degrees/unit/15627"
            },
            "majors": [
                {
                    "name": "Healthcare Administration",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Public Health",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Sciences",
            "source": {
                "label": "UNLV Degrees Directory, College of Sciences",
                "url": "https://www.unlv.edu/academics/degrees/unit/15619"
            },
            "majors": [
                {
                    "name": "Biochemistry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Chemistry",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Chemistry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Earth and Environmental Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "General Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Geology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Mathematics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Mathematics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Physics",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "Greenspun College of Urban Affairs",
            "source": {
                "label": "UNLV Degrees Directory, Greenspun College of Urban Affairs",
                "url": "https://www.unlv.edu/academics/degrees/unit/15618"
            },
            "majors": [
                {
                    "name": "Communication Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Journalism and Media Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Public Policy and Leadership",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Social Work",
                    "degree": "Bachelor of Social Work"
                }
            ]
        }
    ]
};

export default majors;
